import type { CookiePromosProps } from '../interfaces/Promotions';

export const PROMOTION_COOKIE = 'promotions';
export const INIT_PROMO_COOKIES: CookiePromosProps = { hidden: {} };
